import React from "react";
import { ShimmerPostList } from "react-shimmer-effects";

const Shimmer=() =>{

    return <ShimmerPostList postStyle="STYLE_FOUR" col={3} row={2} gap={30} />;
}
export default Shimmer;

